export default "__VITE_ASSET__ba86ed41__"